interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const GridMenuIcon = ({ width = 16, height = 16, color = 'black' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.81181 0H1.21815C0.546422 0 0 0.546422 0 1.21815V5.81181C0 6.48353 0.546422 7.02996 1.21815 7.02996H5.81181C6.48353 7.02996 7.02996 6.48353 7.02996 5.81181V1.21815C7.02985 0.546422 6.48353 0 5.81181 0Z'
        fill={color}
      />
      <path
        d='M14.7815 0H10.1879C9.51615 0 8.96973 0.546422 8.96973 1.21815V5.81181C8.96973 6.48353 9.51615 7.02996 10.1879 7.02996H14.7815C15.4533 7.02996 15.9997 6.48353 15.9997 5.81181V1.21815C15.9997 0.546422 15.4533 0 14.7815 0Z'
        fill={color}
      />
      <path
        d='M5.81181 8.97003H1.21815C0.546422 8.97003 0 9.5164 0 10.1881V14.7818C0 15.4535 0.546422 15.9999 1.21815 15.9999H5.81181C6.48353 15.9999 7.02996 15.4535 7.02996 14.7818V10.1881C7.02985 9.5164 6.48353 8.97003 5.81181 8.97003Z'
        fill={color}
      />
      <path
        d='M14.7815 8.97003H10.1879C9.51615 8.97003 8.96973 9.51645 8.96973 10.1882V14.7818C8.96973 15.4536 9.51615 16 10.1879 16H14.7815C15.4533 15.9999 15.9997 15.4535 15.9997 14.7818V10.1881C15.9997 9.5164 15.4533 8.97003 14.7815 8.97003Z'
        fill={color}
      />
    </svg>
  );
};

export default GridMenuIcon;
